import { Box, Chip, CircularProgress, IconButton } from "@mui/material"
import WalletIcon from '@mui/icons-material/Wallet'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'

import { memo, useContext, useState } from "react"
import { Context } from "./Context"
import { deletingPaycode } from "../../../utils/Timecard"
import { GlobalContext } from "../../../GlobalContext"
import moment from "moment"

const PaycodeEditCell = memo(({params}) => {
    const {
        apiRef,
        setOpenAddPaycode,
        setRow,
    } = useContext(Context);

    return(
        <>
            <Box 
                sx={{
                    width: '100%',
                    display:'grid', 
                    placeItems: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                    gap: '10px',
                    p: 1.5
                }}
            >
                <IconButton 
                    onClick={() => { 
                        apiRef.current.stopCellEditMode({ id: params?.id, field: params?.field, ignoreModifications: true });
                        //apiRef.current.startCellEditMode({ id: params?.id, field: params?.field });
                        setOpenAddPaycode(true)
                        setRow(params?.row)
                    }}
                >
                    <AddIcon/>
                </IconButton>
            </Box>
        </>
    )
})

const ChipPaycode = memo(({paycode, params}) => {
    const [loading, setLoading] = useState(false);

    const {
        reloading,
    } = useContext(Context);

    const {
        handlerAlert,
    } = useContext(GlobalContext)

    return(
        <Chip 
            disabled={params?.row?.open_period.open === false}
            color={paycode.color}
            icon={
                <WalletIcon sx={{mr: 4}}/>
            } 
            label={<Box sx={{width: '80px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}>{paycode?.paycode}</Box>}
            sx={{width: '150px'}}
            onDelete={() => { 
                if(loading){
                    console.log('loading...');
                }else{
                    deletingPaycode(setLoading, params?.row?.person_number, paycode.date, paycode, reloading,  handlerAlert)
                }
            }}
            deleteIcon={
                loading ?
                    <CircularProgress size={20} color="inherit" />
                    :
                    <DeleteIcon/>
            }
        />
    )
})

const PaycodeCell = memo(({params}) => {
    const regex = /auto-generated-row-null/;

    const {
        apiRef,
        periods,
        range1,
    } = useContext(Context);

    const gettingOpacity = () => {
        const period = periods.find(period => period.full_name === params?.rowNode?.groupingKey)

        if(period){
            if(moment(period.end_date, 'YYYY-MM-DD').isSameOrAfter(moment(range1[1], 'YYYY-MM-DD'))){
                return 0.5
            }else{
                return 1
            }
        }else{
            return 1
        }
    }

    const rows = params?.rowNode?.children ? params?.rowNode?.children?.map(id => apiRef.current.getRow(id)) : []

    const totals = rows.reduce((acc, row) => {
        return acc + row?.paycodes.length
    }, 0)

    return (
        <>
            <Box 
                sx={{
                    width: '100%',
                    display:'grid', 
                    placeItems: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                    gap: '10px',
                    p: 1.5
                }}
            >
                { regex.test(params?.id) ?
                    <Box sx={{ opacity: gettingOpacity() }}>
                        {totals}
                    </Box>
                    :
                    <>
                        { params?.value?.map((paycode, index) => 
                            <ChipPaycode 
                                key={`paycode-${index}-${paycode.date}-${paycode.type}-${paycode.paycode}-${paycode.amount}`}
                                paycode={paycode}
                                params={params}
                            />
                        )}
                    </>
                }
            </Box>
        </>
    )
})

export { 
    PaycodeEditCell,
    PaycodeCell,
}